/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from 'react';
import { useForkRef } from '../useForkRef';
/**
 * Хук для того чтобы навешать ref на React-элемент на котором уже может быть навешен ref
 *
 * Возвращает клонированный элемент и ref-объект этого элемента
 *
 * @export
 * @template T
 * @param {React.ReactElement} element
 * @returns [React.ReactElement, React.RefObject<T>]
 */

export function useElementForkRef(element) {
  var elementRef = React.useRef(null);
  var handleElementRef = useForkRef(elementRef, element.ref);
  var refferedElement = /*#__PURE__*/React.cloneElement(element, {
    ref: handleElementRef
  });
  return [refferedElement, elementRef];
}